import { formatMoney } from "@/shared/utils/formatters";
import type { StripeConnection } from "../types/stripeTypes";

// Stripe reports amounts in the currency's smallest unit.
export function formatStripeMinorAmount(minor: number, currency: string) {
  const digits = new Intl.NumberFormat("en-US", { style: "currency", currency }).resolvedOptions().maximumFractionDigits ?? 2;
  return formatMoney(minor / 10 ** digits, currency);
}

export const isStripeFinanceAvailable = (status: StripeConnection["status"]) =>
  status !== "not_connected" && status !== "connection_removed";

/** Whole-percent change, or null when there is no positive baseline to compare with. */
export function getStripePercentChange(current: number, previous: number | undefined): number | null {
  if (previous === undefined || previous <= 0) return null;
  return Math.round(((current - previous) / previous) * 100);
}
